module.exports = __webpack_public_path__ + "img/14.8c00f5a1.png";